import type { SupplyTableProduct } from '@/services/supplyService';

/**
 * Misma regla que `_sort_supply_rows_global` en backend:
 * cantidad_sugerida_sistema desc, desempate id desc.
 */
export function compareSupplyTableRows(
  a: SupplyTableProduct,
  b: SupplyTableProduct,
): number {
  const qtyA = Number(a.cantidad_sugerida_sistema ?? 0);
  const qtyB = Number(b.cantidad_sugerida_sistema ?? 0);
  if (qtyB !== qtyA) {
    return qtyB - qtyA;
  }
  return b.id - a.id;
}

export function sortSupplyTableRows(rows: SupplyTableProduct[]): SupplyTableProduct[] {
  return [...rows].sort(compareSupplyTableRows);
}
